import {
  AfterViewChecked,
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild
} from '@angular/core';
import {
  FormGroup,
  Validators,
  FormBuilder,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import { StorageService } from 'src/app/core/storage/storage.service';
import { CoreService } from '../../../core/services/core.service';
import i18next from 'i18next';
import { FeedbackModalComponent } from 'src/app/shared/components/feedback-modal/feedback-modal.component';
import { HttpErrorResponse } from '@angular/common/http';
import { ControlErrors } from 'src/app/shared/utils/generateError';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { I18NextModule } from 'angular-i18next';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatDialog } from '@angular/material/dialog';

@Component({
  standalone: true,
  selector: 'app-confirm-new-password',
  templateUrl: './confirm-new-password.component.html',
  styleUrls: ['./confirm-new-password.component.scss'],
  imports: [
    FeedbackModalComponent,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    I18NextModule,
    MatCardModule,
    MatFormFieldModule,
    MatInputModule
  ]
})
export class ConfirmNewPasswordComponent
  implements OnInit, AfterViewInit, AfterViewChecked
{
  @ViewChild('autofocus') autofocus!: ElementRef<HTMLInputElement>;

  pattern = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[ -/:-@[-`{-~]).{12,60}$';
  errorMessage = '';
  userPassword = {
    nis: '',
    code: '',
    password: ''
  };
  resendCodeText = '';
  passwordTranslate = i18next.t('passwordTranslate');
  spinner = false;

  constructor(
    private fb: FormBuilder,
    private storageService: StorageService,
    private coreService: CoreService,
    private controlErrors: ControlErrors,
    private dialog: MatDialog,
    private readonly changeDetectorRef: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.userPassword.nis = this.storageService.get('config');
  }

  ngAfterViewInit() {
    this.autofocus.nativeElement.focus();
  }

  ngAfterViewChecked(): void {
    this.changeDetectorRef.detectChanges();
  }

  formPassword: FormGroup = this.fb.group({
    code: [
      '',
      [Validators.required, Validators.minLength(6), Validators.maxLength(6)]
    ],
    password: ['', [Validators.required, Validators.pattern(this.pattern)]],
    repeatPassword: [
      '',
      [Validators.required, Validators.pattern(this.pattern)]
    ]
  });

  controlInput(input: string): boolean {
    return (
      this.formPassword?.controls[input]?.invalid &&
      this.formPassword?.controls[input]?.touched
    );
  }

  resendCode() {
    this.coreService.forgotPassword(this.userPassword.nis).subscribe({
      next: () => {
        this.resendCodeText = i18next.t('emailVerificationResendFeedbackOk');
      },
      error: () => {
        this.resendCodeText = i18next.t('emailVerificationResendFeedbackKo');
      }
    });
  }

  onSubmit() {
    this.userPassword.code = this.formPassword.value.code;
    this.userPassword.password = this.formPassword.value.password;
    if (
      this.formPassword.value.password ===
      this.formPassword.value.repeatPassword
    ) {
      this.spinner = true;
      this.coreService
        .confirmPassword(
          this.userPassword.nis,
          this.userPassword.code,
          this.userPassword.password
        )
        .subscribe({
          next: () => {
            this.spinner = false;
            this.dialog.open(FeedbackModalComponent, {
              width: '400px',
              data: {
                text: i18next.t('passwordChangeSuccess'),
                redirect: true,
                list: false,
                cancelOrder: false,
                theme: 'dark'
              }
            });
          },
          error: (err: HttpErrorResponse) => {
            this.spinner = false;
            this.errorMessage = this.controlErrors.generateError(
              err.error.message,
              i18next.t('genericErr')
            );
          }
        });
    } else {
      this.errorMessage = i18next.t('passwordErr');
    }
  }

  errorMsg(input: string) {
    if (
      this.formPassword?.controls[input]?.invalid &&
      this.formPassword?.controls[input]?.touched
    ) {
      return 'error-message';
    } else {
      return 'info-text';
    }
  }
}
